import { IAffairPub } from "@api/affair.int";
import { IUserPub } from "@api/auth.int";
import { IProfileAffairsGetApi } from "@api/profile.int";
import { Box, Text, useBoolean } from "@chakra-ui/react";
import { useDeepAuth, useVVApi } from "components/api";
import { AFFAIR_KINDS, Bogyo } from "components/appComponents";
import { DeepErrorBox, DeepErrorContainer } from "components/misc";
import { isLocationAffair, useVVStore } from "components/store";
import { formatDateTime } from "components/utils";
import { VizvCard, VizvCardContent, VizvCardHeaderPopup, VizvMainCol } from "components/vizvComponents";
import { NavMainLink } from "features/NavMain";
import { useEffect, useState } from "react";
import { Outlet, useNavigate, useParams } from "react-router";



export function ProfileAffairs() {
    const routeParams = useParams();
    const isDetailed = !!routeParams.affairKey;
    const userKey = routeParams.userKey;
    const api = useVVApi();

    const [affairItems, setAffairItems] = useState<IAffairPub[]>([]);
    const auth = useDeepAuth();
    const [isLoading, setIsLoading] = useBoolean();
    const [error, setError] = useState('');

    const itemsList = useVVStore(state => state.itemsList);
    const setSuggestionList = useVVStore(state => state.setSuggestionList);
    const guardList = useVVStore(state => state.guardList);

    const nav = useNavigate();
    const navRoot = `/profile-affairs/${userKey}`;



    useEffect(() => {
        if (!userKey)
            return;
        (async () => {
            try {
                setError('');
                setIsLoading.on();
                const resp = await api.fetch<IProfileAffairsGetApi>({
                    url: '/auth/profile/:userKey/affairs', method: 'GET', params: { userKey }
                });
                setAffairItems(resp.affairs.filter(a => !a.deletedBy));

            } catch (ex) {
                setError(ex + '');
            } finally {
                setIsLoading.off();
            }

        })();

    }, [userKey]);

    const [guard, setGuard] = useState<IUserPub>();
    const [navBack, setNavBack] = useState('')
    useEffect(() => {
        if (!userKey) {
            setGuard(undefined);
            setNavBack('');
        } else if (auth.signedUser?.userKey === userKey) {
            setGuard(auth.userAny);
            setNavBack('');
        } else {
            const g = guardList.find(g => g.userKey === userKey);
            if (g) {
                setGuard(g);
                setNavBack(`/guard/${g.userKey}`);
            } else {
                setGuard(undefined);
                setNavBack('');
            }
        }

    }, [userKey, guardList, auth.signedUser])

    const affairClick = (affair: IAffairPub) => {
        //nav(navRoot + '/affair/' + affair.affairKey);
        const loc = itemsList.find(item => isLocationAffair(item) && item.dbAffair.affairKey === affair.affairKey);
        setSuggestionList(loc ? [loc] : []);
        if (!loc)
            nav(navRoot + '/affair/' + affair.affairKey);
    }

    const affairHover = (affair: IAffairPub) => {
        /*const loc = store.itemsList.find(item => isLocationAffair(item) && item.dbAffair === affair);
        store.setSuggestionList(loc ? [loc] : []);*/
    }


    return <>
        <VizvMainCol isTool={{ width: 400, isDetailed }} mapNavRoot={navRoot} >
            <VizvCard isTool isClosable {...navBack && { onBack: () => nav(navBack) }}>
                <DeepErrorBox isLoading={isLoading} error={error} />
                <VizvCardHeaderPopup fontSize='x-large' fontWeight='400' variant="blue" mb={2}
                //{...parent && { mt: 0 }}
                >
                    {auth && auth.signedUser && userKey && auth.signedUser.userKey == userKey ? 'Bejelentéseim' : (
                        guard ? <Box>
                            <span>{guard.userName}</span><br /><Text fontSize='sm' lineHeight='normal'>Bejelentései</Text>
                        </Box> : 'Bejelentések'
                    )}

                </VizvCardHeaderPopup>
                <Box flex='1' overflowY='auto' overflowX='hidden'>
                    {affairItems.map((affair) => <NavMainLink
                        onClick={() => affairClick(affair)}
                        onMouseEnter={() => affairHover(affair)}
                        key={affair.affairKey}
                        fontSize='small' lineHeight='normal'
                        px={3} py={1} mb={1}
                    >
                        <Bogyo kind={affair.affairKind} />
                        <Box>
                            <Box color='InactiveCaptionText'>{formatDateTime(affair.createdAt)}</Box>
                            <Box>{AFFAIR_KINDS[affair.affairKind].name}</Box>
                            <Box>{affair.title}</Box>
                        </Box>
                    </NavMainLink>)}
                    {!affairItems.length && <VizvCardContent>
                        Nincsenek megjeleníthető bejelentések
                    </VizvCardContent>}


                </Box>

            </VizvCard>
        </VizvMainCol>
        <Outlet />
    </>
}